module.exports = __webpack_public_path__ + "img/chef-animate.4a76e8ac.svg";